import app from "firebase/app";
import "firebase/auth";
import "firebase/firebase-firestore";

const config = {
  apiKey: "AIzaSyCH4tOBH7sRO9XMdOQJRrbqOZ1paKTZ3FA",
  authDomain: "boclaimsapp.firebaseapp.com",
  databaseURL: "https://boclaimsapp.firebaseio.com",
  projectId: "boclaimsapp",
  storageBucket: "boclaimsapp.appspot.com",
  messagingSenderId: "625951793957",
  appId: "1:625951793957:web:18dc92f5242549e33cf0cc"
};

class Firebase {
  constructor() {
    const firebase = app.initializeApp(config);
    const firebase2 = app.initializeApp(config, "Secondary");
    this.auth = firebase.auth();
    this.detachedAuth = firebase2.auth();
    this.db = firebase.firestore();
  }

  login(email, password) {
    return this.auth.signInWithEmailAndPassword(email, password);
  }

  logoutDes() {
    console.log("logueado pa fuera");
    this.auth.signOut();

    return window.location.reload();
  }

  logout() {
    console.log("logueado pa fuera");

    return this.auth.signOut();
  }
  /*
  async delete(email, password) {
    const firebase3 = app.initializeApp(config, email);
    this.detachedAuth3 = firebase3.auth();

    try {
      this.detachedAuth3.signOut();
    } catch (err) {
      console.log(err);
    }

    try {
      this.detachedAuth3.signInWithEmailAndPassword(email, password);
      const user = this.detachedAuth3.currentUser;

      console.log(user);
      user
        .delete()
        .then(function() {
          console.log("borrado");
        })
        .catch(function(error) {
          console.log("algo salio mal");
        });
      return this.detachedAuth.signOut();
    } catch (err) {
      console.log(err);
    }
    try {
      this.detachedAuth3.signOut();
    } catch (err) {
      console.log(err);
    }
  }*/
  //////////////////////////////////////////////////////////////////////////////////////////////////////
  async edit(
    nombre,
    email,
    rolLabel,
    password,
    nombreN,
    emailN,
    rolLabelN,
    passwordN
  ) {
    try {
      this.detachedAuth.signOut();
    } catch (err) {
      console.log(err);
    }
    console.log("edicion ejecutada");
    console.log(nombre, email, rolLabel, password);
    console.log(nombreN, emailN, rolLabelN, passwordN);
    try {
      await this.detachedAuth
        .signInWithEmailAndPassword(email, password)
        .then(function(user) {
          console.log("se reautentica");
          console.log(user);
        });

      const user = await this.detachedAuth.currentUser;

      if (password !== passwordN) {
        console.log("los passwords son diferentes");

        await user
          .updatePassword(passwordN)
          .then(function() {
            console.log("password cambiado");
          })
          .catch(function(err) {
            console.log(err);
          });
      }

      if (email !== emailN) {
        await user
          .updateEmail(emailN)
          .then(function() {
            console.log("correo cambiado");
          })
          .catch(function(error) {
            console.log(error);
          });
      }

      if (nombre !== nombreN) {
        await user
          .updateProfile({
            displayName: nombreN
          })
          .then(function() {
            console.log(user.displayName, " se cambio el nombre");
          })
          .catch(function(error) {
            console.log(error, "Pos no, algo salio mal");
          });
      }

      try {
        this.detachedAuth.signOut();
      } catch (err) {
        console.log(err);
      }
    } catch (err) {
      console.log(err);
    }
    try {
      await this.detachedAuth.signOut();
    } catch (err) {
      console.log(err);
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////

  async register(name, email, password, rol) {
    console.log(name, email, password, rol);
    let y = false;
    try {
      await this.detachedAuth
        .createUserWithEmailAndPassword(email, password)
        .then(function(firebaseUser) {
          console.log("usuario creado correctamente!");
          y = true;
        });
    } catch (err) {
      console.log("Error: el usuario (e-mail) ya se encuentra registrado!");
      console.log(err);
      return false;
    }

    if (y) {
      this.db
        .collection("usuarios")

        .add({
          nombre: name,
          email: email,
          rol: rol,
          contra: password,
          status: true
        });

      console.log(
        "usuario :" +
          name +
          "\n" +
          "email :" +
          email +
          "\n" +
          "contraseña :" +
          password +
          "\n" +
          "ha sido creado "
      );
    } else {
      console.log("Fallo!");
    }

    this.detachedAuth.currentUser.updateProfile({
      displayName: name
    });

    return y;
  }

  async registerC(name, email, password, rol) {
    console.log(name, email, password, rol);
    let y = false;
    try {
      await this.detachedAuth
        .createUserWithEmailAndPassword(email, password)
        .then(function(firebaseUser) {
          console.log(
            "Se ha creado un Usuario Nuevo para este caso, se agregara el caso.."
          );
          y = true;
        });
    } catch (err) {
      console.log(
        "Se econtro que el usuario (e-mail) ya se encuentra registrado, se le agregara el caso."
      );
      console.log(err);
      return false;
    }

    if (y) {
      this.db
        .collection("usuarios")

        .add({
          nombre: name,
          email: email,
          rol: rol,
          contra: password,
          status: true
        });

      console.log(
        "usuario :" +
          name +
          "\n" +
          "email :" +
          email +
          "\n" +
          "contraseña :" +
          password +
          "\n" +
          "ha sido creado "
      );
    } else {
      console.log(
        "usuario :" +
          name +
          "\n" +
          "email :" +
          email +
          "\n" +
          "contraseña :" +
          password +
          "\n" +
          "Usuario previamente existente "
      );
    }
    this.detachedAuth.currentUser.updateProfile({
      displayName: name
    });

    return y;
  }
  ////////////////////////////////////////////////////// ((((((( ACtivar/Desactuvar)))))))
  async status(name, email, password, rol) {}
  /////////////////////////////////////////////////////////// ((((((((((()))))))))))

  addQuote(quote) {
    if (!this.auth.currentUser) {
      return alert("Not authorized");
    }

    return this.db
      .doc(`users_codedamn_video/${this.auth.currentUser.uid}`)
      .set({
        quote
      });
  }

  isInitialized() {
    return new Promise(resolve => {
      this.auth.onAuthStateChanged(resolve);
    });
  }

  getCurrentUsername() {
    return this.auth.currentUser && this.auth.currentUser.displayName;
  }

  async getCurrentUserQuote() {
    const quote = await this.db
      .doc(`users_codedamn_video/${this.auth.currentUser.uid}`)
      .get();
    return quote.get("quote");
  }
}

export default new Firebase();

/* const credential = this.detachedAuth.EmailAuthProvider.credential(
        email,
        password
      );

      // Prompt the user to re-provide their sign-in credentials

      user
        .reauthenticateWithCredential(credential)
        .then(function() {
          console.log(" User re-authenticated.");
        })
        .catch(function(error) {
          console.log(" An error happened.");
        });
      console.log(credential);*/
